export const GET_TRANSACTION_DETAIL = {
    REQUEST: 'GET_TRANSACTION_DETAIL_REQUEST',
    SUCCESS: 'GET_TRANSACTION_DETAIL_SUCCESS',
    FAILED: 'GET_TRANSACTION_DETAIL_FAILED',
};

export const UPDATE_TRANSACTION = 'TRANSACTION.LIST_TRANSACTION.UPDATE';

export const CLEAR_STATE = 'CLEAR_STATE';
